module.exports = __webpack_public_path__ + "static/banner-3-concert-hall-49ee8954dccfd8391256a89d87ebc415.jpg";